export const createArrayNumbers = (
  length: number,
  /**
   * the first number in array
   * @defaultValue 1
   */
  startWith = 1
) => Array.from({ length }, (_, index) => index + startWith);
